(function() {
    angular
        .module('emarket.main.store')
        .controller('StoreListController', ['$log', '$scope', '$timeout', '$location', '$rootScope', '$window', 'Profile', 'Category', function($log,
            $scope,
            $timeout,
            $location,
            $rootScope,
            $window,
            Profile,
            Category) {
            var vm = this;
            var query = {};
            var LIMIT = 25;
            var timeout;
            vm.filter = {
                categories: []
            };

            vm.categories = Category.$search({
                parentId: 0
            });

            vm.datasource = {
                get: function(descriptor, success) {
                    descriptor.index--;
                    if (descriptor.index < 0) {
                        descriptor.count += descriptor.index;
                        descriptor.index = 0;
                        descriptor.count = descriptor.count < 0 ? 0 : descriptor.count;
                    }
                    query.hasStore = true;
                    query.$limit = descriptor.count;
                    query.$skip = descriptor.index;

                    Profile.$search(query)
                        .$asPromise()
                        .then(function(stores) {
                            success(stores);
                        })
                        .catch(function() {
                            success([]);
                        });
                }
            };
            var getStore = function() {
                var skip = parseInt($location.search().omitir);
                query.hasStore = true;
                query.$limit = LIMIT;
                query.$skip = skip;
                vm.loading = true;
                if (!skip || skip === 0) {
                    vm.hidePrev = true;
                    vm.hideNext = false;
                } else {
                    vm.hidePrev = false;
                }
                $window.scrollTo(0, 0);
                Profile.$search(query)
                    .$asPromise()
                    .then(function(stores) {
                        vm.stores = stores;
                        vm.loading = false;
                    })
                    .catch(function() {
                        vm.loading = false;
                    });
            };

            var next = function() {
                var skip = $location.search().omitir || 0;
                skip = parseInt(skip);
                $location.search('omitir', skip + LIMIT);
            };
            var prev = function() {
                var skip = $location.search().omitir || 0;
                skip = parseInt(skip);
                skip = skip === 0 ? 0 : skip - LIMIT;
                $location.search('omitir', skip);
            };
            vm.next = next;
            vm.prev = prev;

            vm.filterByCategory = function(category) {
                // $log.info(category);
                if (category) {
                    if (category === 'all') {
                        query = {};
                    } else {
                        query.store = {
                            categories: [ category ]
                        };
                    }
                    getStore();
                }
            };
            vm.searchByName = function() {
                if (timeout) {
                    $timeout.cancel(timeout);
                    timeout = null;
                }
                timeout = $timeout(function() {
                    if (vm.q) {
                        query.q = vm.q;
                    } else {
                        delete query.q;
                    }
                    getStore();
                }, 400);
            };
            var ev = $rootScope.$on('$locationChangeSuccess', function() {
                getStore();
            });
            getStore();
            // var search = function (query) {
            //     query = query || {};
            //     query.hasStore = true;
            //     vm.loading = true;
            //     Profile.$search(query)
            //         .$asPromise()
            //         .then(function (stores) {
            //             vm.stores = stores;
            //             vm.loading = false;
            //         }).catch(function () {
            //             vm.loading = false;
            //         });
            // };
            //
            // search();
            $scope.$on('$destroy', function() {
                ev();
            });
        }]);
}());
